export default function StructuredData() {
  const jsonLd = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "ConstructionCompany",
        "@id": "https://simoomco.com.au/#top",
        "name": "Simoom Construction",
        "url": "https://simoomco.com.au/",
        "logo": "https://simoomco.com.au/simoomco.webp",
        "description":
          "Simoom Construction is a Queensland-based local builder specialising in residential construction and shop fit-outs, delivering practical, well-crafted spaces for homeowners and business owners across QLD.",
        "address": {
          "@type": "PostalAddress",
          "addressRegion": "QLD",
          "addressCountry": "AU"
        },
        "areaServed": {
          "@type": "AdministrativeArea",
          "name": "Queensland"
        },
        "knowsAbout": [
          "Residential Construction",
          "Home Renovation",
          "Shop Fit-Out",
          "Retail Fit-Out",
          "Interior Construction",
          "Commercial Fit-Out"
        ]
      },
      {
        "@type": "CollectionPage",
        "@id": "https://simoomco.com.au/#services",
        "name": "Selected Projects",
        "hasPart": [
          {
            "@type": "CreativeWork",
            "name": "Residential Project",
            "description":
              "A residential project focusing on functional layout improvements and clean interior finishes."
          },
          {
            "@type": "CreativeWork",
            "name": "Fit-Out Project",
            "description":
              "A small-scale hospitality fit-out delivering a clean, welcoming and practical dining space."
          }
        ]
      },
      {
        "@type": "WebSite",
        "@id": "https://simoomco.com.au/",
        "url": "https://simoomco.com.au/",
        "name": "Simoom Construction",
        "publisher": {
          "@id": "https://simoomco.com.au/#top"
        }
      }
    ]
  }

  return (
    <>
      {/* SEO Meta Tags */}
      <title>Simoom Construction | QLD Residential & Shop Fit-Out Builder</title>
      <meta
        name="description"
        content="Simoom Construction is a Queensland-based local builder specialising in residential and shop fit-outs. High-quality, practical, and stylish construction solutions across QLD."
      />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href="https://simoomco.com.au/" />
      <meta
        property="og:title"
        content="Simoom Construction | QLD Residential & Shop Fit-Out Builder"
      />
      <meta
        property="og:description"
        content="Queensland local builder specialising in residential and shop fit-outs. Practical and well-crafted spaces."
      />
      <meta property="og:url" content="https://simoomco.com.au/" />
      <meta property="og:type" content="website" />
      <meta property="og:image" content="https://simoomco.com.au/og-image.jpg" />

      {/* JSON-LD Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify(jsonLd),
        }}
      />
    </>
  )
}
